import React from 'react'
import Home from '../components/Home';

const Index = ({pageContext}) => 
    <Home {...pageContext}/>

export default Index;
